<ng-container
  chartBinding

  chartTimeframeController
  [chartTimeframeSelector]="tfs.timeframe$"
  [timesframes]="'Timeframes' | element | async | dataToTimeframes"

  timeframePreselection
  [timeframeSelector]="tfs">

  <div class="value-dev-chart-header">
    <wct-datepicker
      [variant]="'start'"
      [range]="('Timeframes' | element | async | dataToTimeframes)?.['Aufl.']"
      [chartTimeframeChange]="tfs.timeframe$"/>

    <wct-datepicker
      [variant]="'end'"
      [range]="('Timeframes' | element | async | dataToTimeframes)?.['Aufl.']"
      [chartTimeframeChange]="tfs.timeframe$"/>

    <wct-time-frame-selection #tfs [activeButtons]="'Timeframes' | element | async | dataToTimeframes" />
  </div>

  @if (data) {
    <div
      class="stockgraph highcharts-light stockgraph-no-main-lines chart-container"
      highcharts-chart
      [Highcharts]="Highstock"
      [constructorType]="'stockChart'"
      [sizeStrategy]="sizeStrategy"
      [runOutsideAngular]="true"
      [options]="data | transformChartOptions: legacyOptionsTransformer : chartTransformer"></div>
  }
</ng-container>
